export const MAX_TRANSFER_ORDER_LINES_PER_CREATE = 50;
export const MAX_TRANSFER_ORDER_LINES_PER_CREATE_MESSAGE = `A maximum of ${MAX_TRANSFER_ORDER_LINES_PER_CREATE} items can be transferred at a time.`;
export const MAX_TRANSFER_ORDER_LOCATION_FILTER_IDS = 200;
export const TRANSFER_ORDER_CONSTRAINTS = {
    brand: { label: 'Brand' },
    fromLocationGroup: { label: 'Source warehouse' },
    shipToLocationGroup: { label: 'Destination warehouse' },
    carrier: { label: 'Carrier' },
    carrierService: { label: 'Carrier service' },
    dateScheduled: { label: 'Est. ship date' },
    note: { maxLength: 4000, label: 'Notes' },
    part: { label: 'Item' },
    quantity: {
        label: 'Quantity',
        min: 0.000000001,
        minText: '0.000000001',
        max: 1_000_000_000,
        maxText: '1,000,000,000',
    },
    items: { label: 'Items to transfer' },
};
//# sourceMappingURL=constraints.js.map